import {
	useFormErrorNotification,
	useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import useInvalidateShop from "./use-invalidate-shop";

type UseRemoveShopStoreParams = {
	shopId: string;
	storeId: string;
};

export default function useRemoveShopStore({
	shopId,
	storeId,
}: UseRemoveShopStoreParams) {
	const successNotification = useFormSuccessNotification();
	const errorNotification = useFormErrorNotification();
	const invalidateShop = useInvalidateShop(shopId);
	const mutation = $api.useMutation(
		"delete",
		"/shops/{shopId}/return-to-store/stores/{storeId}",
	);

	return useMutation({
		onError: () => {
			errorNotification();
		},
		onSuccess: () => {
			invalidateShop();
			successNotification();
		},
		mutationFn: async () => {
			return mutation.mutateAsync({
				params: { path: { storeId, shopId } },
			});
		},
	});
}
